import React from "react";
import ContactUs from "./ContactUs";

import "./CyberSecurity.css";
// import syllabusPDF from "../assets/CyberSecuritySyllabus.pdf";

const CyberSecurity = () => {
  return (
    <>
      {/* ✅ Main Cyber Security Course Section */}
      <section className="cyber-section">
        <div className="cyber-container">
          <h1 className="cyber-title">Cyber Security Training Course</h1>
          <p className="cyber-subtitle">Ethical Hacking • Network Security • SOC</p>

          <div className="cyber-rating">
            <span>⭐ 4.9 Reviews</span>
          </div>

          <div className="cyber-duration">
            <p><strong>Duration:</strong> 3 to 4 Months</p>
            <p><strong>15+ Guaranteed Interviews</strong></p>
          </div>

          <div className="cyber-description">
            <p>
              Secure the digital world with our industry-focused
              <strong> Cyber Security Training Course</strong>.
              Cyber Security protects systems, networks, and data from
              cyber threats, attacks, and unauthorized access in today’s
              technology-driven world.
            </p>

            {/* <button
              className="cyber-btn"
              onClick={() => window.open(syllabusPDF, "_blank")}
            >
              📘 Download Syllabus
            </button> */}
          </div>

          <h2 className="cyber-heading">
            Boost Your Career with Cyber Security Course in Indore
          </h2>
          <p className="cyber-text">
            This Cyber Security course is designed to take you from beginner
            to job-ready professional. Whether you are a student, IT
            professional, or networking enthusiast, this course builds a
            strong foundation in security concepts and real-world practices.
          </p>

          <h2 className="cyber-heading">What You Will Learn?</h2>
          <p className="cyber-text">
            Learn from certified security experts with hands-on labs,
            real-time attack simulations, and practical defensive techniques
            used by professionals worldwide.
          </p>

          <ul className="cyber-list">
            <li>
              <strong>Cyber Security Fundamentals:</strong> Understand
              security principles, CIA triad, threats, vulnerabilities, and
              attack vectors.
            </li>
            <li>
              <strong>Network & Web Security:</strong> Learn firewalls,
              IDS/IPS, HTTP/HTTPS, SSL/TLS, and common web attacks like SQL
              Injection and XSS.
            </li>
            <li>
              <strong>Ethical Hacking:</strong> Explore penetration testing,
              reconnaissance, vulnerability scanning, and exploitation
              techniques.
            </li>
            <li>
              <strong>Malware & System Security:</strong> Study malware
              types, system hardening, antivirus concepts, and endpoint
              protection.
            </li>
            <li>
              <strong>SOC & Incident Response:</strong> Learn SIEM tools,
              log analysis, monitoring, incident handling, and basic digital
              forensics.
            </li>
          </ul>

          <h2 className="cyber-heading">
            Why choose Codex Future for Cyber Security Training?
          </h2>
          <p className="cyber-text">
            Cyber Security professionals are in huge demand worldwide.
            <strong> Codex Future Indore</strong> offers hands-on training,
            live projects, placement support, and interview preparation to
            help you land roles like SOC Analyst, Security Engineer, or
            Ethical Hacker.
          </p>

          <p className="cyber-text">
            Our Cyber Security course focuses on both defensive and offensive
            security skills aligned with current industry requirements.
          </p>
        </div>
      </section>

      {/* ✅ Bottom Contact Section */}
      <ContactUs />
    </>
  );
};

export default CyberSecurity;
